import { AlarmNotification } from '@interfaces/alarm/alarm-notification';
import { Task, TaskStatus } from '@interfaces/task/task';

export function mapAlarmToTask(alarm: AlarmNotification): Task {
  return {
    departments: alarm?.data?.location?.department
      ? [alarm.data.location.department]
      : undefined,

    type: 'ALARM_NOTIFICATION',
    sequence: alarm.sequence,

    data: {
      filterDepts: alarm.data.filterDepts?.map((fd) => ({
        unit: fd.unit,
        department: fd.department,
      })),
      type: alarm.data.alarm,
      icon: alarm.data.icon,
      description: alarm.data.description,
      location: alarm.data.location?.name ?? alarm.data.location,
      startTime: alarm.data.startTime as unknown as string,
      title: alarm.data.alarm,
      additionalDetails: alarm.data.additionalInfo,
    },

    isTask: false,
    isHighlighted: false,
    isRead: false,

    key: alarm.key,
    status: TaskStatus.ACTIVE,
  };
}
